import { useEffect, useState } from "react";
import TableContainer from '../../Component/TableContainer';
import Menu2 from '../Menu2';
import config from "../../Config/config";
import "../../Style/ViewLine.css"

import TrainloadProvider from "../../Store/TrainloadProvider";

function TWL() {

    const [configName] = useState("twl_config");

    useEffect(() => {
        document.title = config[configName].line;
    });

    const LineTitle = () => {
        return (
            <div className="viewline">
                <h1>{config[configName].line}</h1>
                <p>{config[configName].line_full}</p>
            </div>
        );
    }

    return (
        <>
            <TrainloadProvider>
                <Menu2 lineTitle= {LineTitle}></Menu2>

                <TableContainer config={config[configName]} traintypes={config.traintype_arr} index_label={config.index_label} />
            </TrainloadProvider>
        </>
    );
}

export default TWL;